import React from "react";
import { connect } from "react-redux";
import { DashboardHeader } from "../../components/Header";
import Invoices from "../../components/Invoice/Invoices";
import language from "../../language";

class InvoiceScreen extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={language[this.props.defaultLanguage].invoices}
            titleClassName="text-primary"
          />
          <Invoices showAdd />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(InvoiceScreen);
